/* eslint-disable camelcase */
import scanlineMapUtils from '../../../../../mapUtils';
import { createIsValidReading, deriveDataSetsFromProps } from './_BASE';

export const createDerivedSurveys = (
	processedReadings,
	processedReadingsWithChartGaps,
	processedReadingsWithGeoGaps,
	type,
	surveyReadings,
	jobId,
	meta,
	end_date,
	parent_survey_subtype,
	job_number
) => {
	const readings = {};
	const readingsWithChartGaps = {};
	const readingsWithGeoGaps = {};
	const readingsMap = {};
	const readingsIndexMap = {};
	const readingsWithChartGapsIndexMap = {};
	const readingsWithGeoGapsIndexMap = {};

	const series = {};
	const seriesIndexMap = {};

	const readingsMeta = {};
	const surveys = [];
	const { s3Key } = meta || {};
	const readingsStationIdIntegers = {};

	const survey = scanlineMapUtils.createSurveyTemplate(type, 'DOC', {
		primaryXAxis: {
			minimum: surveyReadings[0].id,
			maximum: surveyReadings[surveyReadings.length - 1].id
		},
		jobId,
		s3Key,
		end_date,
		parent_survey_subtype,
		job_number
	});
	survey.isDerived = true;
	scanlineMapUtils.initSurveyMeta(survey);
	const readingKeyProps = survey.meta.getReadingKeyProps();
	const isValidReading = createIsValidReading(readingKeyProps);

	if (processedReadings.filter(isValidReading).length) {
		const {
			readings: thisReadings,
			readingsIndexMap: thisReadingsIndexMap,
			readingsMap: thisReadingsMap,
			readingsWithChartGaps: thisReadingsWithChartGaps,
			readingsWithChartGapsIndexMap: thisReadingsWithChartGapsIndexMap,
			readingsWithGeoGapsIndexMap: thisReadingsWithGeoGapsIndexMap,
			readingsWithGeoGaps: thisReadingsWithGeoGaps,
			series: thisSeries,
			seriesIndexMap: thisSeriesIndexMap,
			readingsStationIdIntegers: thisReadingsStationIdIntegers
		} = deriveDataSetsFromProps(
			survey,
			readingKeyProps,
			processedReadings,
			processedReadingsWithChartGaps,
			processedReadingsWithGeoGaps,
			{ surveyMeta: survey.meta }
		);

		readings[survey.id] = thisReadings;
		readingsWithChartGaps[survey.id] = thisReadingsWithChartGaps;
		readingsWithGeoGaps[survey.id] = thisReadingsWithGeoGaps;
		readingsIndexMap[survey.id] = thisReadingsIndexMap;
		readingsWithChartGapsIndexMap[
			survey.id
		] = thisReadingsWithChartGapsIndexMap;
		readingsWithGeoGapsIndexMap[survey.id] = thisReadingsWithGeoGapsIndexMap;
		readingsMap[survey.id] = thisReadingsMap;
		series[survey.id] = thisSeries;
		seriesIndexMap[survey.id] = thisSeriesIndexMap;
		readingsMeta[survey.id] = meta;
		readingsStationIdIntegers[survey.id] = thisReadingsStationIdIntegers;

		surveys.push(survey);
	}

	return {
		readings,
		readingsWithChartGaps,
		readingsWithGeoGaps,
		readingsMap,
		readingsIndexMap,
		readingsWithChartGapsIndexMap,
		readingsWithGeoGapsIndexMap,
		readingsMeta,
		surveys,
		series,
		seriesIndexMap,
		readingsStationIdIntegers
	};
};

export default { createDerivedSurveys };
